
export class FFFightCard {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "FFFightCard";
    this.scene = "FFFightCard";
    this.data = [];
    this.page = 9007;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      console.log(options?.cachedGames)

      // Fight One
      xml.payload.field.find((item) => {
        return item.attr.name === "1742";
      }).value = (options?.activeGames.cachedGames[0]?.home_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames.cachedGames[0]?.home_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1744";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames.cachedGames[0]?.home_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1746";
      }).value = (options?.activeGames.cachedGames[0]?.home_fighter?.style.toUpperCase()  || "");
      
      xml.payload.field.find((item) => {
        return item.attr.name === "1752";
      }).value = (options?.activeGames.cachedGames[0].away_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames.cachedGames[0].away_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1754";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames.cachedGames[0].away_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1756";
      }).value = (options?.activeGames.cachedGames[0].away_fighter?.style.toUpperCase()  || "");

            // Fight Two
      xml.payload.field.find((item) => {
        return item.attr.name === "1722";
      }).value = (options?.activeGames[1].home_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames[1].home_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1724";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames[1].home_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1726";
      }).value = (options?.activeGames[1].home_fighter?.style.toUpperCase()  || "");
      
      xml.payload.field.find((item) => {
        return item.attr.name === "1732";
      }).value = (options?.activeGames[1].away_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames[1].away_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1734";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames[1].away_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1736";
      }).value = (options?.activeGames[1].away_fighter?.style.toUpperCase()  || "");

       // Fight Three
      xml.payload.field.find((item) => {
        return item.attr.name === "1702";
      }).value = (options?.activeGames[2].home_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames[2].home_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1704";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames[2].home_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1706";
      }).value = (options?.activeGames[2].home_fighter?.style.toUpperCase()  || "");
      
      xml.payload.field.find((item) => {
        return item.attr.name === "1712";
      }).value = (options?.activeGames[2].away_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames[2].away_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1714";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames[2].away_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1716";
      }).value = (options?.activeGames[2].away_fighter?.style.toUpperCase()  || "");

        // Fight Four
      xml.payload.field.find((item) => {
        return item.attr.name === "1682";
      }).value = (options?.activeGames[3].home_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames[3].home_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1684";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames[3].home_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1686";
      }).value = (options?.activeGames[3].home_fighter?.style.toUpperCase()  || "");
      
      xml.payload.field.find((item) => {
        return item.attr.name === "1692";
      }).value = (options?.activeGames[3].away_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames[3].away_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1694";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames[3].away_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1696";
      }).value = (options?.activeGames[3].away_fighter?.style.toUpperCase()  || "");

              // Fight Five
      xml.payload.field.find((item) => {
        return item.attr.name === "1662";
      }).value = (options?.activeGames[4].home_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames[4].home_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1664";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames[4].home_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1666";
      }).value = (options?.activeGames[4].home_fighter?.style.toUpperCase()  || "");
      
      xml.payload.field.find((item) => {
        return item.attr.name === "1672";
      }).value = (options?.activeGames[4].away_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames[4].away_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1674";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames[4].away_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1676";
      }).value = (options?.activeGames[4].away_fighter?.style.toUpperCase()  || "");
      
             // Fight Six
      xml.payload.field.find((item) => {
        return item.attr.name === "1642";
      }).value = (options?.activeGames[5].home_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames[5].home_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1644";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames[5].home_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1646";
      }).value = (options?.activeGames[5].home_fighter?.style.toUpperCase()  || "");
      
      xml.payload.field.find((item) => {
        return item.attr.name === "1652";
      }).value = (options?.activeGames[5].away_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames[5].away_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1654";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames[5].away_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1656";
      }).value = (options?.activeGames[5].away_fighter?.style.toUpperCase()  || "");

             // Fight Seven
      xml.payload.field.find((item) => {
        return item.attr.name === "1622";
      }).value = (options?.activeGames[6].home_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames[6].home_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1624";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames[6].home_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1626";
      }).value = (options?.activeGames[6].home_fighter?.style.toUpperCase()  || "");
      
      xml.payload.field.find((item) => {
        return item.attr.name === "1632";
      }).value = (options?.activeGames[6].away_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames[6].away_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1634";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames[6].away_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1636";
      }).value = (options?.activeGames[6].away_fighter?.style.toUpperCase()  || "");

      
             // Fight Eight
      xml.payload.field.find((item) => {
        return item.attr.name === "1602";
      }).value = (options?.activeGames[7].home_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames[7].home_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1604";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames[7].home_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1606";
      }).value = (options?.activeGames[7].home_fighter?.style.toUpperCase()  || "");
      
      xml.payload.field.find((item) => {
        return item.attr.name === "1612";
      }).value = (options?.activeGames[7].away_fighter?.first_name.toUpperCase()  || "") + " " + (options?.activeGames[7].away_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1614";
      }).value = options?.game?.competition?.flag_path + (options?.activeGames[7].away_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1616";
      }).value = (options?.activeGames[7].away_fighter?.style.toUpperCase()  || "");

      // Fight Results

      xml.payload.field.find((item) => {
        return item.attr.name === "172";
      }).value = options?.activeGame[7].completed;




      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
